import React from 'react';

import { convertStyleData, transformPx2Rem, getGoodsTypeByForm, convertTagStyle, convertHtmlTag } from '@utils/tools';
import { appMethod as app } from '@utils/app';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';
import { utils } from '@utils/util';
import './GoodsListCustomComponent.less';
/**
 * type: "goods-list" 
 * 组件：商品列表
 * 描述：电商、到店、预约的商品列表显示组件
 * 
 * 组件配置对象
 * customFeature.addShoppingCartImageSrc 控制购物车按钮
 * 
 * customFeature.mode 列表类型
 * 
 */

let hotelDefaultTime = function (date) {
  var date = new Date(date) || new Date(),
    nextDate = new Date((new Date().setDate(date.getDate() + 1))),
    dayList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    start_day = dayList[date.getDay()],
    end_day = dayList[nextDate.getDay()],
    start_date = date.getMonth() + 1 + '月' + date.getDate() + '日',
    end_date = nextDate.getMonth() + 1 + '月' + nextDate.getDate() + '日';
  return {
    start_day: start_day,
    end_day: end_day,
    start_date: start_date,
    end_date: end_date
  }
}

export default class GoodsListCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }
  /**
   * 当前组件内部方法
   */
  /**
   * 初始化
   */
  init = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let param = {
      id: customFeature['id'],
      form: customFeature['form'],
      goods_type: getGoodsTypeByForm(customFeature['form']),
      tpl_id: customFeature['tplId'],
      page: 1,
      is_count: 0,
    };
    pageInstance.setData({
      ['eles[' + compindex + '].param']: param
    });
    let newInitData = {};
    newInitData['eles[' + compindex + '].goods_data'] = [];
    newInitData['eles[' + compindex + '].is_more'] = 1;
    newInitData['eles[' + compindex + '].loadingFail'] = false;
    newInitData['eles[' + compindex + '].loading'] = true;
    newInitData['eles[' + compindex + '].curpage'] = 0;
    pageInstance.setData(newInitData);

    param.page = 1;
    if (customFeature.controlCheck) {
      param.is_integral = 3;
    } else {
      if (customFeature.isIntegral) {
        param.is_integral = 1;
      } else {
        param.is_integral = 5;
      }
    }
    if (customFeature.isShowGroupBuyGoods) {
      param.is_group_buy = 1;
    }
    param.is_count = 0;
    param.page_size = customFeature.loadingNum || 10;

    if (customFeature.source && customFeature.source != 'none') {
      param.idx_arr = {
        "idx": "category",
        "idx_value": customFeature.source
      }
    }

    if (param.form === 'goods' && customFeature.pickUpArr) {
      param.pick_up_type = [];
      if (customFeature.pickUpArr.express) {
        param.pick_up_type.push(1);
      }

      if (customFeature.pickUpArr.sameJourney) {
        param.pick_up_type.push(2);
      }

      if (customFeature.pickUpArr.selfLifting) {
        param.pick_up_type.push(3);
      }

      if (customFeature.pickUpArr.dining) {
        if (customFeature.form === 'goods' && customFeature.isShowFranchiseeGoods) {
          // 子店点餐商品先不显示
        } else {
          param.pick_up_type.push(4);
        }
      }
    }

    if (customFeature.form === 'goods' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) { // 显示子店商品 // TODO
      param['is_app_shop_cate_goods'] = 1;
      param['is_app_shop'] = 1;
    }

    pageInstance.setData({
      ['eles[' + compindex + '].param']: param
    });

    if (param.form === 'tostore') {
      this.tostoreInit(compindex, pageInstance, param);
    } else if (param.form == 'new_appointment') {
      this.newAppointmentInit(compindex, pageInstance, param);
    } else {
      this.goodsListInit(compindex, pageInstance, param);
    }
  }

  tostoreInit = (compindex, pageInstance, param) => {
    if (app.isLogin()) {
      app.getTostoreCartList();
    }

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '', // TODO: 未处理
      success: function (res) {
        let newdata = {};
        let goodslist = res.data;
        // TODO: 尚未处理
        if (app.getHomepageRouter() == pageInstance.state.router) {
          let second = new Date().getMinutes().toString();
          if (second.length <= 1) {
            second = '0' + second;
          }
          let currentTime = new Date().getHours().toString() + second,
            showFlag = true,
            showTime = '';

          app.sendRequest({
            hideLoading: true,
            url: '/index.php?r=AppShop/getBusinessTime',
            method: 'post',
            data: {
            },
            chain: true,
            subshop: pageInstance.franchiseeId || '', // TODO
            success: function (res) {
              let businessTime = res.data.business_time;
              if (businessTime && businessTime.length) {
                for (let i = 0; i < businessTime.length; i++) {
                  showTime += businessTime[i].start_time.substring(0, 2) + ':' + businessTime[i].start_time.substring(2, 4) + '-' + businessTime[i].end_time.substring(0, 2) + ':' + businessTime[i].end_time.substring(2, 4) + (businessTime.length == 1 ? '' : (i <= businessTime.length - 1 ? ' / ' : ''));
                  if (+currentTime > +businessTime[i].start_time && +currentTime < +businessTime[i].end_time) {
                    showFlag = false;
                  }
                }
              }
              if (showFlag) {
                app.showModal({
                  content: '店铺休息中,暂时无法接单。营业时间为：' + showTime
                })
              }
            }
          });
        }
        goodslist.map((item) => {
          item.form_data.goods_model && delete item.form_data.goods_model
        })
        newdata['eles[' + compindex + '].goods_data'] = goodslist;
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  getAptGoodsList = (compindex, pageInstance, param, customFeature) => {
    let noAppointTpl = {};
    noAppointTpl['eles[' + compindex + '].param'] = param;
    noAppointTpl['eles[' + compindex + '].customFeature.tpl_id'] = param.tpl_id;
    noAppointTpl['eles[' + compindex + '].customFeature.unit'] = param.unit;
    noAppointTpl['eles[' + compindex + '].customFeature.now_date'] = new Date().getTime();

    if (!param.tpl_id) {
      noAppointTpl['eles[' + compindex + '].goods_data'] = [];
      noAppointTpl['eles[' + compindex + '].is_more'] = 0;
      noAppointTpl['eles[' + compindex + '].loadingFail'] = false;
      noAppointTpl['eles[' + compindex + '].loading'] = false;
      pageInstance.setData(noAppointTpl);
      return
    }
    pageInstance.setData(noAppointTpl);

    let isClassify = false;
    if (pageInstance.newClassifyGroupidsParams && !!pageInstance.newClassifyGroupidsParams.length) {
      let params = pageInstance.newClassifyGroupidsParams;
      for (let i = 0; i < params.length; i++) {
        let newClassifyCompindex = params[i].compindex;
        if (!pageInstance.data.eles[newClassifyCompindex].hidden && pageInstance.data.eles[newClassifyCompindex].customFeature.refresh_object == customFeature.id) {
          isClassify = true;
        }
      }
    }
    if (!isClassify) {
      app.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/GetGoodsList',
        data: param,
        method: 'post',
        chain: true,
        subshop: pageInstance.franchiseeId || '',
        success: function (res) {
          if (res.status == 0) {
            for (let i in res.data) {
              res.data[i].form_data.price = res.data[i].form_data.min_price;
              delete res.data[i].form_data.description;
            }
            let newdata = {};
            newdata['eles[' + compindex + '].goods_data'] = res.data;
            newdata['eles[' + compindex + '].is_more'] = res.is_more;
            newdata['eles[' + compindex + '].curpage'] = 1;
            newdata['eles[' + compindex + '].loadingFail'] = false;
            newdata['eles[' + compindex + '].loading'] = false;
            pageInstance.setData(newdata);
          }
        },
        fail: function (res) {
          let newdata = {};
          newdata['eles[' + compindex + '].loadingFail'] = true;
          newdata['eles[' + compindex + '].loading'] = false;
          pageInstance.setData(newdata);
        }
      });
    }
  }

  newAppointmentInit = (compindex, pageInstance, param) => {
    let self = this;
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    if (customFeature.trade_apt_id) {
      param.tpl_id = customFeature.trade_apt_id;
      param.unit = customFeature.unitType;
      self.getAptGoodsList(compindex, pageInstance, param, customFeature)
    } else {
      app.sendRequest({
        url: '/index.php?r=AppAppointment/GetUsedTpl',
        method: 'POST',
        hideLoading: true,
        chain: true,
        subshop: pageInstance.franchiseeId || '',
        success(res) {
          param.tpl_id = res.data.length ? res.data[0].id : '';
          param.unit = res.data.length ? res.data[0].unit : '';
          self.getAptGoodsList(compindex, pageInstance, param)
        },
        fail: function (res) {
          let newdata = {};
          newdata['eles[' + compindex + '].loadingFail'] = true;
          newdata['eles[' + compindex + '].loading'] = false;
          pageInstance.setData(newdata);
        }
      })
    }
  }

  goodsListInit = (compindex, pageInstance, param) => {
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let isClassify = false;

    if (app.getInvolvedFromRefreshObject(customFeature.id, "new-classify")) {
      isClassify = true;
    }

    if (!isClassify) {
      app.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/GetGoodsList',
        data: param,
        method: 'post',
        chain: true,
        subshop: pageInstance.franchiseeId || '', // TODO
        success: function (res) {
          let appId = app.getAppId();
          if (res.status == 0) {
            for (let i in res.data) {
              if (res.data[i].form_data.goods_model) {
                let minPrice = res.data[i].form_data.goods_model[0].price;
                let virtualMinPrice;
                res.data[i].form_data.goods_model.map((goods) => {
                  if (+minPrice >= +goods.price) {
                    minPrice = goods.price;
                    virtualMinPrice = goods.virtual_price;
                  }
                })
                res.data[i].form_data.virtual_price = virtualMinPrice;
                res.data[i].form_data.price = minPrice;
              }
              res.data[i].form_data.discount = (res.data[i].form_data.price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
              let vip_discount = (res.data[i].form_data.vip_min_price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
              res.data[i].form_data.vip_discount = vip_discount < 0.01 ? 0.01 : vip_discount;
              delete res.data[i].form_data.description;

              if (+param['is_app_shop_cate_goods'] === 1 && res.data[i].form_data.app_id !== appId && !pageInstance.franchiseeId) {
                res.data[i].form_data.isSubShopGoods = true;
              } else {
                res.data[i].form_data.isSubShopGoods = false;
              }
              let formData = res.data[i].form_data;
              if (formData.app_shop_data && formData.app_shop_data.distance != undefined) {
                let distance = formData.app_shop_data.distance;
                formData.app_shop_data.distance = util.formatDistance(distance);
              }
            }
            let newdata = {};
            newdata['eles[' + compindex + '].goods_data'] = res.data;
            newdata['eles[' + compindex + '].is_more'] = res.is_more;
            newdata['eles[' + compindex + '].curpage'] = 1;
            newdata['eles[' + compindex + '].loadingFail'] = false;
            newdata['eles[' + compindex + '].loading'] = false;
            pageInstance.setData(newdata);
          }
        },
        fail: function (res) {
          let newdata = {};
          newdata['eles[' + compindex + '].loadingFail'] = true;
          newdata['eles[' + compindex + '].loading'] = false;
          pageInstance.setData(newdata);
        }
      });
    }
    // 电商店铺风格
    if (param.form === 'goods') {
      app.getAppECStoreConfig((res) => {
        let newdata = {};
        newdata['eles[' + compindex + '].storeStyle'] = res.color_config;
        pageInstance.setData(newdata);
      })
    }
  }

  _goodsScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData = pageInstance.data.eles[compindex];
    let curpage = compData.curpage + 1;
    let customFeature = compData.customFeature;
    let newdata = {};
    let param = compData.param;

    if (!compData.is_more && typeof event == 'object' && event.type == 'tap') {
      app.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    //行业预约  模板为空兼容
    if (param.form == 'new_appointment' && !param.tpl_id) {
      let noAppointTpl = {};
      noAppointTpl['eles[' + compindex + '].goods_data'] = [];
      noAppointTpl['eles[' + compindex + '].is_more'] = 0;
      pageInstance.setData(noAppointTpl)
      return
    }

    param.page = curpage;
    app.sendRequest({
      url: '/index.php?r=AppShop/GetGoodsList',
      hideLoading: true,
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '', // TODO
      success: function (res) {
        let newdata = {};
        let appId = app.getAppId();
        for (let i in res.data) {
          if (res.data[i].form_data.goods_model) {
            let minPrice = res.data[i].form_data.goods_model[0].price;
            let virtualMinPrice;
            res.data[i].form_data.goods_model.map((goods) => {
              if (+minPrice >= +goods.price) {
                minPrice = goods.price;
                virtualMinPrice = goods.virtual_price;
              }
            })
            res.data[i].form_data.virtual_price = virtualMinPrice;
            res.data[i].form_data.price = minPrice;
          }
          res.data[i].form_data.discount = (res.data[i].form_data.price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
          let vip_discount = (res.data[i].form_data.vip_min_price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
          res.data[i].form_data.vip_discount = vip_discount < 0.01 ? 0.01 : vip_discount;
          delete res.data[i].form_data.description;
          res.data[i].form_data.goods_model && delete res.data[i].form_data.goods_model;

          if (+param['is_app_shop_cate_goods'] === 1 && res.data[i].form_data.app_id !== appId && !pageInstance.franchiseeId) {
            res.data[i].form_data.isSubShopGoods = true;
          } else {
            res.data[i].form_data.isSubShopGoods = false;
          }
          let formData = res.data[i].form_data;
          if (formData.app_shop_data && formData.app_shop_data.distance != undefined) {
            let distance = formData.app_shop_data.distance;
            formData.app_shop_data.distance = util.formatDistance(distance);
          }
        }
        if (res.current_page == 1) {
          compData.goods_data = [];
        }
        newdata['eles[' + compindex + '].goods_data'] = compData.goods_data.concat(res.data);
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;

        pageInstance.setData(newdata);
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {

      }
    })
  }

  _refreshGoodsList = (targetCompIndex, requestData, pageInstance) => {
    let customFeature = pageInstance.data.eles[targetCompIndex].customFeature;
    let newData = {};

    newData['eles[' + targetCompIndex + '].loading'] = true;
    newData['eles[' + targetCompIndex + '].loadingFail'] = false;
    newData['eles[' + targetCompIndex + '].is_more'] = 1;
    newData['eles[' + targetCompIndex + '].goods_data'] = [];
    newData['eles[' + targetCompIndex + '].param'] = requestData;
    pageInstance.setData(newData);

    requestData.page_size = customFeature.loadingNum || 10;

    if (customFeature.form === 'goods' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) { // 显示子店商品(排除子店功能页)
      requestData['is_app_shop_cate_goods'] = 1;
      requestData['is_app_shop'] = 1;
    }

    app.sendRequest({
      url: '/index.php?r=AppShop/GetGoodsList',
      method: 'post',
      hideLoading: true,
      data: requestData,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let newData = {};
        let appId = app.getAppId();
        for (let i in res.data) {
          if (res.data[i].form_data.goods_model) {
            let minPrice = res.data[i].form_data.goods_model[0].price;
            let virtualMinPrice;
            res.data[i].form_data.goods_model.map((goods) => {
              if (+minPrice >= +goods.price) {
                minPrice = goods.price;
                virtualMinPrice = goods.virtual_price;
              }
            })
            res.data[i].form_data.virtual_price = virtualMinPrice;
            res.data[i].form_data.price = minPrice;
          }
          res.data[i].form_data.discount = (res.data[i].form_data.price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
          let vip_discount = (res.data[i].form_data.vip_min_price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
          res.data[i].form_data.vip_discount = vip_discount < 0.01 ? 0.01 : vip_discount;
          res.data[i].form_data.goods_model && delete res.data[i].form_data.goods_model;

          if (+requestData['is_app_shop_cate_goods'] === 1 && res.data[i].form_data.app_id !== appId) {
            res.data[i].form_data.isSubShopGoods = true;
          } else {
            res.data[i].form_data.isSubShopGoods = false;
          }
        }
        newData['eles[' + targetCompIndex + '].goods_data'] = res.data;
        newData['eles[' + targetCompIndex + '].is_more'] = res.is_more;
        newData['eles[' + targetCompIndex + '].curpage'] = 1;
        newData['eles[' + targetCompIndex + '].scrollTop'] = 0;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        newData['eles[' + targetCompIndex + '].loadingFail'] = false;
        pageInstance.setData(newData);
      },
      fail: function (res) {
        let newData = {};
        newData['eles[' + targetCompIndex + '].loadingFail'] = true;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newData);
      }
    })
  }

  goodsScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData = pageInstance.data.eles[compindex];
    if (compData.is_search) {
      // 与搜索组件相关联
      let searchComponentIndex = compData.searchEle;
      pageInstance.callComponentMethod({
        componentIndex: searchComponentIndex,
        methodName: 'searchList',
        argvs: [searchComponentIndex, event]
      });
    } else {
      this._goodsScrollFunc(event);
    }
  }

  turnToGoodsDetail = (event) => {
    let dataset = event.currentTarget.dataset;
    let id = dataset.id;
    let contact = dataset.contact;
    let goodsType = dataset.goodsType;
    let group = dataset.group;
    let hidestock = dataset.hidestock;
    let isShowVirtualPrice = dataset.isshowvirtualprice;
    let unit = dataset.unit;

    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (dataset.appId && dataset.appId !== app.getAppId() && chainParam === '') { // 跳转子店商品
      chainParam += '&franchisee=' + dataset.appId;
    }
    if (group && group == 1) {
      app.turnToPage('gpgoodsDetail?goods_id=' + id + '&activity_id=' + dataset.groupid + '&contact=' + contact + chainParam);
      return;
    }
    switch (+goodsType) {
      case 0: app.turnToPage('goodsDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + '&isShowVirtualPrice=' + isShowVirtualPrice + chainParam);
        break;
      case 1: app.turnToPage('goodsDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + chainParam);
        break;
      case 3: app.turnToPage('toStoreDetail?detail=' + id + chainParam);
        break;
      case 10:
        if (unit) {
          app.turnToPage('hotel?contact=' + contact + '&hidestock=' + hidestock + chainParam);
        } else {
          app.turnToPage('newAppointmentDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + chainParam);
        }
        break;
    }
  }

  showGoodsShoppingcart = (e) => {
    e.stopPropagation();
    if (e.currentTarget.dataset.appId && e.currentTarget.dataset.appId !== app.getAppId()) {
      app.showModal({
        content: '子店商品添加到购物车需要在商品详情页购物车购买',
        confirm: () => {
          app.showGoodsShoppingcart(e);
        }
      });
    } else {
      app.showGoodsShoppingcart(e);
    }
  }

  showAddShoppingcart = (e) => {
    e.stopPropagation();
    if (e.currentTarget.dataset.appId && e.currentTarget.dataset.appId !== app.getAppId()) {
      app.showModal({
        content: '子店商品添加到购物车需要在商品详情页购物车购买',
        confirm: () => {
          app.showAddShoppingcart(e);
        }
      });
    } else {
      app.showAddShoppingcart(e);
    }
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    if (!data.storeStyle) {
      data.storeStyle = {};
    }
    const styleObj = convertStyleData(data.style);
    styleObj['fontSize'] = transformPx2Rem(data.style['font-size'], 320); // 计算后重新覆盖值
    if (customFeature.vesselAutoheight == 0) {
      styleObj['height'] = transformPx2Rem(customFeature['height'], 320);
    }
    const itemStyleObj = {
      marginBottom: transformPx2Rem(customFeature.margin, 320),
      backgroundColor: customFeature.lineBackgroundColor,
      backgroundImage: customFeature.lineBackgroundImage,
      height: transformPx2Rem(customFeature.lineHeight, 320),
    }
    const itemImgStyleObj = {
      width: transformPx2Rem(customFeature.imgWidth, 320),
      height: transformPx2Rem(customFeature.imgHeight, 320),
    }
    // 图片大小根据模式进行调整
    if (customFeature.mode == 3) {
      itemImgStyleObj['width'] = '100%';
    }
    // 内容部分（非图片）的宽度
    let contentWidth = null;
    // 根据列表类型设置
    switch (customFeature.mode) {
      // 单列
      case 0:
        contentWidth = `calc(100% - ${itemImgStyleObj.width})`;
        break;
      // 双列、大图
      case 1:
      case 3:
        contentWidth = `100%`;
        break;
      // 横向
      case 2:
        contentWidth = `${itemImgStyleObj.width}`;
        break;
      default:
        contentWidth = `calc(100% - ${itemImgStyleObj.width})`;
        break;
    }

    // 判断购物车按钮是否为图片
    const isImage = function (string) {
      var a = string || 'addshoppingcart1';
      return a.indexOf('addshoppingcart');
    }

    // 判断商品是否包邮
    const isFree = function (goods) {
      var expressFeeSort = goods.form_data.goods_express_data.express_fee_sort;
      if (expressFeeSort.length == 1 && expressFeeSort[0] == 0) {
        return true;
      } else {
        return false;
      }
    }

    /**
     * 加载状态/点击按钮
     */
    const Others = () => {
      // 是否为竖版
      const hor = customFeature.mode == 2 && data.curpage > 0;
      return (
        <React.Fragment>
          {/* 加载loading */}
          {
            data.loading &&
            <RequestStatus is="requestLoading" hor={hor}></RequestStatus>
          }
          {/* 加载没有数据 */}
          {
            data.is_more == 0 && data.goods_data.length == 0 &&
            <RequestStatus is="requestNone" data={{ data: '暂无商品数据~' }} hor={hor}></RequestStatus>
          }
          {/* 加载失败 */}
          {
            data.loadingFail &&
            <RequestStatus is="requestFail" data={{ refreshEvent: 'goodsScrollFunc', compindex: this.props.index }} hor={hor}></RequestStatus>
          }
          {/* 加载完所有数据 */}
          {
            data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText &&
            <RequestStatus is="requestAll" hor={hor}></RequestStatus>
          }
          {/* 点击加载按钮 */}
          {
            data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail &&
            <LoadingBtn customFeature={customFeature} onClick={this.goodsScrollFunc} data-compindex={this.props.index}></LoadingBtn>
          }
        </React.Fragment>
      )
    }

    /**
     * 积分商品列表
     */
    const IntegralGoodsList = () => (
      <ScrollView
        className={`goods-list goods-list-mode-${customFeature.mode} ${(data.customFeature.mode == 2 && data.curpage > 0) ? 'hor-request-status' : ''}`}
        style={styleObj}
        scroll-x={data.customFeature.mode == 2 ? true : false}
        scroll-y={(data.customFeature.mode == 2 || data.customFeature.vesselAutoheight != 0) ? false : true}
        scroll-top={data.scrollTop}
        bindscrolltolower={this.goodsScrollFunc}
        data-compindex={this.props.index}
      // bindanimationend="animationEnd"
      >
        {
          data.customFeature.mode !== 3 && (
            <div className="js-list-container">
              {
                data.goods_data && data.goods_data.map((item, index) => (
                  <div className="goods-list-item background-ele" key={index} data-id={item.form_data.id}
                    style={{
                      ...itemStyleObj,
                      height: data.customFeature.mode !== 0 ? (data.customFeature.mode === 1 ? '300px ' : '280px') : itemStyleObj.height,
                      marginBottom: data.customFeature.mode !== 0 ? '0px' : ''
                    }}
                    data-contact={data.customFeature.ifUseContact}
                    data-goods-type={item.form_data.goods_type}
                    data-group={item.form_data.is_group_buy}
                    data-presell={item.form_data.is_presell_goods}
                    data-groupid={item.form_data.group_buy_activity_id}
                    data-hidestock={data.customFeature.isHideStock || ''}
                    data-isshowvirtualprice={data.customFeature.isShowVirtualPrice}
                    data-app-id={item.form_data.app_id}
                    onClick={this.turnToGoodsDetail}>
                    <div className="inner-content" style={{ verticalAlign: 'top' }}>
                      <img className="list-img" src={item.form_data.cover} style={{
                        ...itemImgStyleObj,
                        position: 'relative'
                      }} />
                      {
                        item.form_data.corner_mark > 0 &&
                        <img className="goods-subscript" src={item.form_data.corner_url} />
                      }
                      <div className="title-container" style={{
                        width: contentWidth
                      }}>
                        <div className="title">
                          {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                        </div>
                        {
                          data.customFeature.isShowVirtualPrice && data.customFeature.form == 'goods' ?
                            (
                              data.customFeature.mode == 0 ?
                                <React.Fragment>
                                  {
                                    data.customFeature.isHideSales &&
                                    <div style={{
                                      width: contentWidth,
                                      position: 'absolute',
                                      bottom: 0,
                                      paddingLeft: '.20rem',
                                      height: '60%'
                                    }}>
                                      <div className="price" style={{
                                        marginBottom: '.10rem',
                                        color: data.storeStyle.theme
                                      }}>
                                        {
                                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                          <span style={{
                                            'fontSize': '.28125rem',
                                            'marginRight': '.10rem'
                                          }}>¥</span>
                                        }
                                        {
                                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                          <span>{(item.form_data.goods_type != '1' ? item.form_data.price : (item.form_data.price != '0.00' ? item.form_data.price : '免费'))}</span>
                                        }
                                        {
                                          item.form_data.max_can_use_integral != 0 && item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                          <span>+</span>
                                        }
                                        {
                                          item.form_data.max_can_use_integral != 0 &&
                                          <span>{item.form_data.max_can_use_integral}积分</span>
                                        }
                                      </div >
                                      <div style={{
                                        bottom: 0
                                      }}>
                                        <span className="sales">销量：{item.form_data.sales}</span>
                                        {
                                          item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) >= 0) && (data.customFeature.form == 'goods' || data.customFeature.form == 'tostore') &&
                                          <label className={`addShoppingcart ico-moon icon-${data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'}`} data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}></label>
                                        }
                                        {
                                          item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) && (data.customFeature.form == 'goods' || data.customFeature.form == 'tostore') &&
                                          <label className="addShoppingcart shoppingImage" data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id}
                                            onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}>
                                            <img src={data.customFeature.addShoppingCartImageSrc} />
                                          </label>

                                        }
                                      </div >
                                    </div >
                                  }
                                  {
                                    !data.customFeature.isHideSales &&
                                    <div style={{
                                      width: contentWidth,
                                      paddingLeft: '.20rem'
                                    }}>
                                      <div className="price" style={{ color: data.storeStyle.theme }}>
                                        {
                                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                          <span style={{
                                            fontSize: '.28125rem',
                                            marginRight: '.1rem',
                                            color: data.storeStyle.theme
                                          }}>¥</span>
                                        }
                                        {
                                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                          <span style={{ color: data.storeStyle.theme }}>{(item.form_data.goods_type != '1' ? item.form_data.price : (item.form_data.price != '0.00' ? item.form_data.price : '免费'))}</span>
                                        }
                                        {
                                          item.form_data.max_can_use_integral != 0 && item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                          <span style={{ color: data.storeStyle.theme }}>+</span>
                                        }
                                        {
                                          item.form_data.max_can_use_integral != 0 &&
                                          <span style={{ color: data.storeStyle.theme }}>{item.form_data.max_can_use_integral}积分</span>
                                        }
                                      </div>
                                    </div>
                                  }
                                </React.Fragment>
                                :
                                <div style={{
                                  width: contentWidth,
                                }}>
                                  <div style={{
                                    paddingLeft: 0
                                  }}>
                                    <div className="integral-flex-wrap">
                                      {
                                        item.form_data.price != '0.00' &&
                                        <span className="price" style={{ color: data.storeStyle.theme }}>¥{item.form_data.price}</span>
                                      }
                                      <span>
                                        {
                                          item.form_data.max_can_use_integral != 0 && item.form_data.price != '0.00' &&
                                          <span className="price" style={{ color: data.storeStyle.theme }}>+</span>
                                        }
                                        {
                                          item.form_data.max_can_use_integral != 0 &&
                                          <span className="price" style={{ color: data.storeStyle.theme }}>{item.form_data.max_can_use_integral}积分</span>
                                        }
                                      </span>
                                    </div>
                                  </div>
                                  {
                                    data.customFeature.isHideSales &&
                                    <div className="sales">销量：{item.form_data.sales}</div>
                                  }
                                </div>
                            )
                            :
                            <div style={{
                              width: contentWidth,
                            }}>
                              <div className="integral-flex-wrap">
                                {
                                  item.form_data.price != '0.00' &&
                                  <span className="price" style={{ color: data.storeStyle.theme }}>¥{item.form_data.price}</span>
                                }
                                <span>
                                  {
                                    item.form_data.max_can_use_integral != 0 && item.form_data.price != '0.00' &&
                                    <span className="price" style={{ color: data.storeStyle.theme }}>+</span>
                                  }
                                  {
                                    item.form_data.max_can_use_integral != 0 &&
                                    <span className="price" style={{ color: data.storeStyle.theme }}>{item.form_data.max_can_use_integral}积分</span>
                                  }
                                </span>
                              </div>
                              {
                                data.customFeature.isHideSales &&
                                <span className="sales">销量：{item.form_data.sales}</span>
                              }
                            </div>
                        }
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
          )
        }
        {
          data.customFeature.mode === 3 &&
          <div className="js-list-container four-goods-list" data-list-index="0">
            {
              data.goods_data && data.goods_data.map((item, index) => (
                <div className="goods-list-item background-ele" key={index} style={itemStyleObj} data-id={item.form_data.id} data-contact={data.customFeature.ifUseContact} data-goods-type={item.form_data.goods_type} data-group={item.form_data.is_group_buy} data-presell={item.form_data.is_presell_goods} data-groupid={item.form_data.group_buy_activity_id} data-hidestock={data.customFeature.isHideStock || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice || ''} data-app-id={item.form_data.app_id} onClick={this.turnToGoodsDetail}>
                  <div style={{
                    position: 'relative'
                  }}>
                    {
                      item.form_data.corner_mark > 0 &&
                      <img className="goods-subscript" src={item.form_data.corner_url} />
                    }
                    <img className="list-img" src={item.form_data.cover} style={itemImgStyleObj} mode="scaleToFill" />
                  </div>
                  <div className="four-goods-content">
                    <div className="title">
                      {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                    </div>
                    <div className="price-box">
                      {
                        item.form_data.price != '0.00' &&
                        <span className="integral-price price"
                          style={{ color: data.storeStyle.theme }}>
                          ¥{item.form_data.price}
                        </span>
                      }
                      {
                        item.form_data.max_can_use_integral != 0 &&
                        <span className="integral-price price"
                          style={{ color: data.storeStyle.theme }}>
                          {item.form_data.max_can_use_integral}积分
                        </span>
                      }
                      {
                        item.form_data.virtual_price != 0 && data.customFeature.isShowVirtualPrice &&
                        <span className="virtual_price">
                          ¥{item.form_data.virtual_price}
                        </span>
                      }
                      {
                        !data.customFeature.isHideSales && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) >= 0) &&
                        <label className={`addShoppingcart ico-moon icon-${data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'}`} data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}></label>
                      }
                      {
                        !data.customFeature.isHideSales && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) &&
                        <label className="addShoppingcart shoppingImage" data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}>
                          <img src={data.customFeature.addShoppingCartImageSrc} />
                        </label>
                      }
                    </div>
                    {
                      data.customFeature.isHideSales &&
                      <div className="sales-box" >
                        <span className="sales">销量：{item.form_data.sales}</span>
                      </div>
                    }
                  </div>
                </div>
              ))
            }

          </div>
        }
        <Others></Others>
      </ScrollView>
    );

    /**
     * 原有商品列表
     */
    const GoodsList = () => {
      const defaultTime = function (date) {
        var date = getDate(date) || getDate();
        var nextDate = getDate(getDate().setDate(date.getDate() + 1));
        var dayList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        var start_day = dayList[date.getDay()];
        var end_day = dayList[nextDate.getDay()];
        var start_date = date.getMonth() + 1 + '月' + date.getDate() + '日';
        var end_date = nextDate.getMonth() + 1 + '月' + nextDate.getDate() + '日';
        return {
          start_day: start_day,
          end_day: end_day,
          start_date: start_date,
          end_date: end_date
        }
      }
      return (
        <ScrollView
          className={`goods-list goods-list-mode-${customFeature.mode} ${(data.customFeature.mode == 2 && data.curpage > 0) ? 'hor-request-status' : ''}`}
          style={styleObj}
          scroll-x={data.customFeature.mode == 2 ? true : false}
          scroll-y={(data.customFeature.mode == 2 || data.customFeature.vesselAutoheight != 0) ? false : true}
          scroll-top={data.scrollTop}
          bindscrolltolower={this.goodsScrollFunc}
          data-compindex={this.props.index}
        // bindanimationend="animationEnd"
        >
          {
            data.customFeature.form == 'new_appointment' && data.customFeature.unit == 3 ?
              // 行业预约：酒店
              <div className="js-list-container hotel_appointment" data-goods-type="10" data-unit="1" data-tplid={data.customFeature.tpl_id} onClick={this.turnToGoodsDetail}>
                <div className="hotel-section hotel-area">
                  <div className="hotel-box">
                    <div className="hotel-h">目的地</div>
                  </div>
                  <div className="ico-moon icon-rightarrow"></div>
                </div>
                <div className='hotel-section hotel-time'>
                  <div className='enter-time'>
                    <div className='hotel-h'>{hotelDefaultTime(data.customFeature.now_date).start_day} 入住</div>
                    <div className='hotel-p'>{hotelDefaultTime(data.customFeature.now_date).start_date}</div>
                  </div>
                  <div className='dis-time'>共1晚</div>
                  <div className='leave-time'>
                    <div className='hotel-h'>{hotelDefaultTime(data.customFeature.now_date).end_day} 离店</div>
                    <div className='hotel-p'>{hotelDefaultTime(data.customFeature.now_date).end_date}</div>
                  </div>
                </div>
              </div>
              :
              +data.customFeature.mode !== 3 && data.customFeature.unit != 3 ?
                <div className="js-list-container">
                  {
                    data.goods_data && data.goods_data.map((item, index) => (
                      <div className="goods-list-item background-ele" key={index} style={itemStyleObj} data-id={item.form_data.id} data-goods-type={item.form_data.goods_type} data-group={item.form_data.is_group_buy} data-presell={item.form_data.is_presell_goods} data-groupid={item.form_data.group_buy_activity_id} data-app-id={item.form_data.app_id} onClick={this.turnToGoodsDetail}>
                        <div className="inner-content">
                          <img className="list-img" src={item.form_data.cover} style={{ ...itemImgStyleObj, position: 'relative' }} mode="scaleToFill" />
                          {
                            item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 &&
                            <img className="goods-subscript" src={item.form_data.corner_url} />
                          }
                          <div className="title-container" style={{
                            width: contentWidth
                          }}>
                            <div className="title">
                              {
                                item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                                <img className="title-subscript" src={item.form_data.corner_url} />
                              }
                              {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                            </div>
                            {
                              (data.customFeature.isShowVirtualPrice && (data.customFeature.form == 'goods' || data.customFeature.form == 'new_appointment')) ?
                                (
                                  data.customFeature.mode == 0 ?
                                    (
                                      <React.Fragment>
                                        {
                                          !data.customFeature.isHideSales &&
                                          <div style={{
                                            width: contentWidth,
                                            position: 'absolute',
                                            bottom: 0,
                                            paddingLeft: '.20rem',
                                            height: '60%',
                                          }}>
                                            {
                                              item.form_data.is_vip_goods != 1 ?
                                                <div className="price" style={{
                                                  marginBottom: '.10rem',
                                                  color: data.storeStyle.theme
                                                }}>
                                                  {
                                                    item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                                    <span style={{
                                                      fontSize: '.28125rem',
                                                      marginRight: '.10rem'
                                                    }}>¥</span>
                                                  }
                                                  <span>{(item.form_data.goods_type != '1' ? item.form_data.price : (item.form_data.price != '0.00' ? item.form_data.price : '免费'))}</span>
                                                  {
                                                    item.form_data.virtual_price != 0 &&
                                                    <span className="virtual_price">
                                                      ¥{item.form_data.virtual_price}
                                                    </span>
                                                  }
                                                </div>
                                                :
                                                <div className="price member-price">
                                                  <span className="member-vip-price">
                                                    <span style={{
                                                      fontSize: '.26rem'
                                                    }}>¥</span>
                                                    {item.form_data.vip_min_price}
                                                  </span>
                                                  <span className="vip-logo" style={{
                                                    margin: '0 .10rem 0 .20rem'
                                                  }}>会员价</span>
                                                  {
                                                    item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                                    <span style={{
                                                      fontSize: '.24rem',
                                                      color: '#999'
                                                    }}>
                                                      ¥{(item.form_data.goods_type != '1' ? item.form_data.price : (item.form_data.price != '0.00' ? item.form_data.price : '免费'))}
                                                    </span>
                                                  }
                                                </div>
                                            }
                                            <div style={{
                                              bottom: 0
                                            }}>
                                              <span className="sales">销量：{item.form_data.sales}</span>
                                              {
                                                item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) >= 0) && (data.customFeature.form == 'goods' || data.customFeature.form == 'tostore') &&
                                                <label className={`addShoppingcart ico-moon icon-${data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'}`} data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}></label>
                                              }
                                              {
                                                item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) && (data.customFeature.form == 'goods' || data.customFeature.form == 'tostore') &&
                                                <label className="addShoppingcart shoppingImage" data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}>
                                                  <img src={data.customFeature.addShoppingCartImageSrc} />
                                                </label>
                                              }
                                            </div>
                                          </div>
                                        }
                                        {
                                          data.customFeature.isHideSales &&
                                          <div style={{
                                            width: contentWidth,
                                            paddingLeft: '.20rem',
                                          }}>
                                            {
                                              item.form_data.is_vip_goods != 1 ?
                                                <div className="price" style={{
                                                  color: data.storeStyle.theme
                                                }}>
                                                  {
                                                    item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                                    <span style={{
                                                      fontSize: '.28125rem',
                                                      marginRight: '.10rem'
                                                    }}>
                                                      ¥
                                                    </span>
                                                  }
                                                  <span>
                                                    {(item.form_data.goods_type != '1' ? item.form_data.price : (item.form_data.price != '0.00' ? item.form_data.price : '免费'))}
                                                  </span>
                                                  {
                                                    item.form_data.virtual_price != 0 &&
                                                    <span className="virtual_price">
                                                      ¥{item.form_data.virtual_price}
                                                    </span>
                                                  }
                                                  {
                                                    item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) >= 0) &&
                                                    <label className={`addShoppingcart ico-moon icon-${data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'}`} data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}></label>
                                                  }
                                                  {
                                                    item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) &&
                                                    <label className="addShoppingcart shoppingImage" data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}>
                                                      <img src={data.customFeature.addShoppingCartImageSrc} />
                                                    </label>
                                                  }
                                                </div>
                                                :
                                                <div className="price member-price">
                                                  <span className="member-vip-price">
                                                    <span style={{
                                                      fontSize: '.26rem'
                                                    }}>¥</span>
                                                    {item.form_data.vip_min_price}
                                                  </span>
                                                  <span className="vip-logo" style={{
                                                    margin: '0 .20rem 0 .10rem'
                                                  }}>会员价</span>
                                                  {
                                                    item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                                    <span style={{
                                                      fontSize: '.24rem',
                                                      color: '#999'
                                                    }}>
                                                      ¥{(item.form_data.goods_type != '1' ? item.form_data.price : (item.form_data.price != '0.00' ? item.form_data.price : '免费'))}
                                                    </span>
                                                  }
                                                </div>
                                            }
                                          </div>
                                        }
                                      </React.Fragment>
                                    )
                                    :
                                    (
                                      <div style={{
                                        width: contentWidth
                                      }}>
                                        {
                                          item.form_data.is_vip_goods != 1 ?
                                            <div style={{
                                              paddingLeft: 0
                                            }}>
                                              <span className="price" style={{
                                                color: data.storeStyle.theme
                                              }}>
                                                ¥{item.form_data.price}
                                              </span>
                                              {
                                                item.form_data.virtual_price != 0 &&
                                                <span className="virtual_price" style={{
                                                  marginLeft: 0
                                                }}>
                                                  ¥{item.form_data.virtual_price}
                                                </span>
                                              }
                                            </div>
                                            :
                                            <div className="price member-price">
                                              <span className="member-vip-price">
                                                <span style={{
                                                  fontSize: '.26rem'
                                                }}>¥</span>
                                                {item.form_data.vip_min_price}
                                              </span>
                                              <span className="vip-logo vip-logo-mode-1">会员价</span>
                                              {
                                                item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                                <span style={{
                                                  fontSize: '.24rem',
                                                  color: '#999',
                                                  marginLeft: '.10rem',
                                                }}>
                                                  ¥{(item.form_data.goods_type != '1' ? item.form_data.price : (item.form_data.price != '0.00' ? item.form_data.price : '免费'))}
                                                </span>
                                              }
                                            </div>
                                        }
                                        {
                                          data.customFeature.isHideSales &&
                                          <span className="sales">
                                            销量：{item.form_data.sales}
                                          </span>
                                        }
                                        {
                                          item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) >= 0) &&
                                          <label data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}></label>
                                        }
                                        {
                                          item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) &&
                                          <label className="addShoppingcart shoppingImage" data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}>
                                            <img src={data.customFeature.addShoppingCartImageSrc} />
                                          </label>
                                        }
                                      </div>
                                    )
                                )
                                :
                                (
                                  <div style={{
                                    width: contentWidth
                                  }}>
                                    <span className="price" style={{
                                      color: data.storeStyle.theme
                                    }}>
                                      ¥{item.form_data.price}
                                    </span>
                                    {
                                      !+data.customFeature.isHideSales &&
                                      <span className="sales">
                                        销量：{item.form_data.sales}
                                      </span>
                                    }
                                    {
                                      item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) >= 0) &&
                                      <label className={`addShoppingcart ico-moon icon-${data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'}`} data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}></label>
                                    }
                                    {
                                      item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) &&
                                      <label className="addShoppingcart shoppingImage" data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? 'showGoodsShoppingcart' : 'showAddShoppingcart'}>
                                        <img src={data.customFeature.addShoppingCartImageSrc} />
                                      </label>
                                    }
                                  </div>
                                )
                            }
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
                :
                null
          }
          {
            data.customFeature.mode === 3 && data.customFeature.unit != 3 &&
            <div className="js-list-container four-goods-list">
              {
                data.goods_data && data.goods_data.map((item, index) => (
                  <div className="goods-list-item background-ele" key={index} style={itemStyleObj} data-id={item.form_data.id} data-goods-type={item.form_data.goods_type} data-group={item.form_data.is_group_buy} data-presell={item.form_data.is_presell_goods} data-groupid={item.form_data.group_buy_activity_id} data-app-id={item.form_data.app_id} onClick={this.turnToGoodsDetail}>
                    <div style={{
                      position: 'relative'
                    }}>
                      {
                        item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 &&
                        <img className="goods-subscript" src={item.form_data.corner_url} />
                      }
                      <img className="list-img" src={item.form_data.cover} style={itemImgStyleObj} mode="scaleToFill" />
                    </div>
                    <div className="four-goods-content">
                      <div className="title">
                        {
                          item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                          <img className="title-subscript" src={item.form_data.corner_url} />
                        }
                        {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                      </div>
                      <div className="price-box">
                        {
                          item.form_data.is_vip_goods != 1 ?
                            (
                              <React.Fragment>
                                {
                                  item.form_data.price != '0.00' &&
                                  <span className="integral-price price"
                                    style={{ color: data.storeStyle.theme }}>
                                    ¥{item.form_data.price}
                                  </span>
                                }
                                {
                                  item.form_data.max_can_use_integral != 0 && item.form_data.price != '0.00' &&
                                  <span className="integral-price price"
                                    style={{ color: data.storeStyle.theme }}>+</span>
                                }
                                {
                                  item.form_data.max_can_use_integral != 0 &&
                                  <span className="integral-price price"
                                    style={{ color: data.storeStyle.theme }}>
                                    {item.form_data.max_can_use_integral}积分
                                  </span>
                                }
                                {
                                  item.form_data.virtual_price != 0 && data.customFeature.isShowVirtualPrice && data.customFeature.form == 'goods' &&
                                  <span className="virtual_price">
                                    ¥{item.form_data.virtual_price}
                                  </span>
                                }
                              </React.Fragment>
                            )
                            :
                            (
                              <React.Fragment>
                                <span className="member-vip-price">
                                  <span style={{
                                    fontSize: '.26rem'
                                  }}>¥</span>
                                  {item.form_data.vip_min_price}
                                </span>
                                <span className="vip-logo">会员价</span>
                                {
                                  item.form_data.goods_type != 1 && item.form_data.price != '0.00' &&
                                  <span style={{
                                    fontSize: '.24rem',
                                    color: '#999',
                                    marign: '0 .10rem 0 .20rem'
                                  }}>¥{item.form_data.price}</span>
                                }
                              </React.Fragment>
                            )
                        }
                        {
                          data.customFeature.isHideSales && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) >= 0) &&
                          <label className={`addShoppingcart ico-moon icon-${data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'}`} data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}></label>
                        }
                        {
                          data.customFeature.isHideSales && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) &&
                          <label className="addShoppingcart shoppingImage" data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}>
                            <img src={data.customFeature.addShoppingCartImageSrc} />
                          </label>
                        }
                      </div>
                      {
                        !+data.customFeature.isHideSales &&
                        <div className="sales-box">
                          <span className="sales">销量：{item.form_data.sales}</span>
                          {
                            item.form_data.is_group_buy != 1 && item.form_data.goods_type != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) >= 0) &&
                            <label className={`addShoppingcart ico-moon icon-${data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'}`} data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}></label>
                          }
                          {
                            item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) &&
                            <label className="addShoppingcart shoppingImage" data-id={item.form_data.id} data-buynow={data.customFeature.isBuyNow || ''} data-isshowvirtualprice={data.customFeature.isShowVirtualPrice} data-app-id={item.form_data.app_id} onClick={item.form_data.goods_type == 0 ? this['showGoodsShoppingcart'] : this['showAddShoppingcart']}>
                              <img src={data.customFeature.addShoppingCartImageSrc} />
                            </label>
                          }
                        </div>
                      }
                    </div>
                  </div>
                ))
              }
            </div>
          }
          <Others></Others>
        </ScrollView>
      )
    }

    /**
     * 新版商品列表
     */
    const NewGoodsList = () => (
      <ScrollView
        className={`new-goods-list ${(data.customFeature.mode == 2 && data.curpage > 0) ? 'hor-request-status' : ''}`}
        style={{
          ...styleObj,
          background: data.customFeature.mode != 0 ? '#f3f3f3' : ''
        }}
        scroll-x={data.customFeature.mode == 2 ? true : false}
        scroll-y={data.customFeature.mode == 2 ? false : true}
        scroll-top={data.scrollTop}
        bindscrolltolower={this.goodsScrollFunc}
        data-compindex={this.props.index}
      // bindanimationend="animationEnd"
      >
        {
          data.customFeature.mode == 0 && (
            <React.Fragment>
              {
                data.customFeature.styleMode !== '0-4' ? (
                  <React.Fragment>
                    <div className="new-goods-list-one">
                      {
                        data.goods_data && data.goods_data.map((item, index) => (
                          <div className="goods-content" key={index} data-id={item.form_data.id} data-goods-type={item.form_data.goods_type} data-app-id={item.form_data.app_id} data-group={item.form_data.is_group_buy} data-presell={item.form_data.is_presell_goods} data-groupid={item.form_data.group_buy_activity_id} style={itemStyleObj} onClick={this.turnToGoodsDetail}>
                            <img className="goods-image" src={item.form_data.cover} style={itemImgStyleObj} mode="scaleToFill" />
                            {
                              item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 &&
                              <img className="goods-subscript" src={item.form_data.corner_url} />
                            }
                            {
                              data.customFeature.styleMode == '0-1' &&
                              <div className="goods-detail">
                                <div className="title">
                                  {
                                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                                    <img className="title-subscript" src={item.form_data.corner_url} />
                                  }
                                  {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                                </div>
                                <div className="discount-box">
                                  {
                                    item.form_data.is_vip_goods == 1 &&
                                    <span className="vip-logo" style={{
                                      marginRight: '.10rem'
                                    }}>会员价</span>
                                  }
                                  {
                                    item.form_data.virtual_price != 0 &&
                                    <span className="discount" style={{
                                      color: data.storeStyle.theme,
                                      background: data.storeStyle.theme + '33'
                                    }}>
                                      {
                                        item.form_data.is_vip_goods != 1 ? `${item.form_data.discount}折优惠` : `${item.form_data.vip_discount}折优惠`
                                      }
                                    </span>
                                  }
                                  {
                                    isFree(item) &&
                                    <span className="express" style={{
                                      color: data.storeStyle.theme,
                                      background: data.storeStyle.theme + '33'
                                    }}>包邮</span>
                                  }
                                </div>
                                <div className="price-box">
                                  {
                                    item.form_data.is_vip_goods != 1 ?
                                      <React.Fragment>
                                        <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                        {
                                          item.form_data.virtual_price != 0 &&
                                          <span className="virtual-price">¥{item.form_data.virtual_price}</span>
                                        }
                                      </React.Fragment>
                                      :
                                      <React.Fragment>
                                        <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.vip_min_price}</span>
                                        {
                                          item.form_data.price != 0 &&
                                          <span className="virtual-price" style={{
                                            textDecoration: 'inherit',
                                            position: 'relative',
                                            top: '.02rem'
                                          }}>¥{item.form_data.price}</span>

                                        }
                                      </React.Fragment>
                                  }
                                </div>
                                <div className="sales-box">
                                  <span className="sales">{item.form_data.sales}人付款</span>
                                </div>
                                {
                                  item.form_data.is_group_buy != 1 &&
                                  <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                                }
                              </div>
                            }
                            {
                              data.customFeature.styleMode == '0-2' &&
                              <div className="goods-detail one-two-mode">
                                <div className="title">
                                  {
                                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                                    <img className="title-subscript" src={item.form_data.corner_url} />
                                  }
                                  {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                                </div>
                                {
                                  item.form_data.is_vip_goods == 1 ?
                                    <div className="price-box">
                                      <span style={{
                                        fontSize: '24rpx',
                                        color: '#999',
                                        position: 'relative',
                                        top: '.06rem'
                                      }} className="real-price">¥{item.form_data.price}</span>
                                      {
                                        item.form_data.virtual_price != 0 &&
                                        <span style={{
                                          color: data.storeStyle.theme,
                                          background: data.storeStyle.theme + '33',
                                          position: 'relative',
                                          top: '.05rem'
                                        }} className="discount two-style-discount vip-trangel">
                                          <span style={{
                                            borderRightColor: data.storeStyle.theme + '33',
                                            marginTop: '.10rem'
                                          }} className="trangel"></span>{item.form_data.discount}折
                                        </span>
                                      }
                                      <div>
                                        <span style={{ color: data.storeStyle.theme }}
                                          className="real-price">¥{item.form_data.vip_min_price}</span>
                                        <span style={{
                                          color: data.storeStyle.theme,
                                          background: data.storeStyle.theme + '33',
                                        }} className="discount two-style-discount">
                                          <span style={{
                                            borderRightColor: data.storeStyle.theme + '33'
                                          }} className="trangel"></span>
                                          {item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'}
                                        </span>
                                      </div>
                                    </div>
                                    :
                                    (
                                      <React.Fragment>
                                        {
                                          item.form_data.is_vip_goods != 1 &&
                                          <span className="virtual-price" >{item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''}</span>
                                        }
                                        <div className="price-box">
                                          <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                          {
                                            item.form_data.virtual_price != 0 &&
                                            <span style={{
                                              color: data.storeStyle.theme,
                                              background: data.storeStyle.theme + '33'
                                            }} className="discount two-style-discount">
                                              <span style={{
                                                borderRightColor: data.storeStyle.theme + '33'
                                              }} className="trangel"></span>
                                              {item.form_data.discount}折
                                            </span>
                                          }
                                        </div>
                                      </React.Fragment>
                                    )

                                }
                                <div className="sales-box">
                                  {
                                    isFree(item) &&
                                    <span className="express" style={{
                                      color: data.storeStyle.theme,
                                      borderColor: data.storeStyle.theme + '33'
                                    }}>包邮</span>
                                  }
                                  <span className="sales">{item.form_data.sales}人付款</span>
                                </div>
                                {
                                  item.form_data.is_group_buy != 1 &&
                                  <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                                }
                              </div>
                            }
                            {
                              data.customFeature.styleMode == '0-3' &&
                              <div className="goods-detail one-three-mode">
                                <div className="title">
                                  {
                                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                                    <img className="title-subscript" src={item.form_data.corner_url} />
                                  }
                                  {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                                </div>
                                {
                                  item.form_data.virtual_price != 0 && item.form_data.is_vip_goods !== 1 &&
                                  <span style={{
                                    background: data.storeStyle.theme,
                                  }} className={`discount-sign ico-moon icon-download-sign discount-sign-${(data.storeStyle.theme) ? (data.storeStyle.theme).replace('#', '') : ''}`}>
                                    <span style={{
                                      borderRightColor: data.storeStyle.theme + '33'
                                    }} className="trangel"></span>
                                    {item.form_data.discount}折
                                  </span>
                                }
                                {
                                  item.form_data.is_vip_goods == 1 ?
                                    <div className={`price-box ${item.form_data.virtual_price != 0 && item.form_data.is_vip_goods !== 1 ? '' : 'mgt85'}`}>
                                      <div>
                                        <span style={{ color: data.storeStyle.theme }}
                                          className="real-price">¥{item.form_data.vip_min_price}</span>
                                        <span style={{
                                          color: data.storeStyle.theme,
                                          background: data.storeStyle.theme + '33',
                                        }} className="discount two-style-discount">
                                          <span style={{
                                            borderRightColor: data.storeStyle.theme + '33'
                                          }} className="trangel"></span>
                                          {item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'}
                                        </span>
                                        {
                                          isFree(item) &&
                                          <span className="express" style={{
                                            color: data.storeStyle.theme,
                                            borderColor: data.storeStyle.theme,
                                            background: data.storeStyle.theme ? 'none' : ''
                                          }}>包邮</span>
                                        }
                                      </div>
                                    </div>
                                    :
                                    (
                                      <React.Fragment>

                                        <div className={`price-box ${item.form_data.virtual_price != 0 && item.form_data.is_vip_goods !== 1 ? '' : 'mgt85'}`}>
                                          <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                          {
                                            item.form_data.is_vip_goods != 1 &&
                                            <span className="virtual-price" >{item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''}</span>
                                          }
                                          {
                                            isFree(item) &&
                                            <span className="express" style={{
                                              color: data.storeStyle.theme,
                                              borderColor: data.storeStyle.theme,
                                              background: data.storeStyle.theme ? 'none' : ''
                                            }}>包邮</span>
                                          }
                                        </div>
                                      </React.Fragment>
                                    )

                                }
                                {
                                  item.form_data.is_group_buy != 1 &&
                                  <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                                }
                              </div>
                            }
                          </div>
                        ))
                      }
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="new-goods-list-one-four">
                      {data.goods_data.map((item, index) => {
                        return (
                          <div
                            className="goods-card-content"
                            key={index}
                            data-id={item.form_data.id}
                            data-goods-type={item.form_data.goods_type}
                            data-app-id={item.form_data.app_id}
                            style={itemStyleObj}
                            data-group={item.form_data.is_group_buy}
                            data-presell={item.form_data.is_presell_goods}
                            data-group-id={item.form_data.group_buy_activity_id}
                            data-stock={item.form_data.stock}
                            onClick={this.turnToGoodsDetail}
                          >
                            <img
                              className="goods-image"
                              src={item.form_data.cover}
                              style={itemImgStyleObj}
                              mode="scaleToFill"
                            />
                            {item.form_data.corner_mark > 0 &&
                              item.form_data.corner_position == 0 && (
                                <img
                                  className="goods-subscript"
                                  src={item.form_data.corner_url}
                                />
                              )}
                            {item.form_data.stock == 0 && (
                              <div className="sell-out">
                                <div className="sell-out-btn">已售罄</div>
                              </div>
                            )}

                            <div className="one-four-mode">
                              <div>
                                <div className="title">
                                  {item.form_data.corner_mark > 0 &&
                                    item.form_data.corner_position == 1 && (
                                      <img
                                        className="title-subscript"
                                        src={item.form_data.corner_url}
                                      />
                                    )}
                                  {item.form_data.app_shop_data &&
                                    item.form_data.app_shop_data.name && (
                                      <span>
                                        {'【' +
                                          item.form_data.app_shop_data.name +
                                          '】'}
                                      </span>
                                    )}
                                  {item.form_data.title}
                                </div>
                                <div className="shop-info">
                                  <div className="shop-tags">
                                    <div className="tag-wrap">
                                      {item.form_data.category && item.form_data.category.map((tag, index) => {
                                        return (
                                          <React.Fragment key={index}>
                                            {index ===
                                              item.form_data.category.length -
                                              1 && <span>{tag}</span>}
                                          </React.Fragment>
                                        )
                                      })}
                                    </div>
                                    <div>
                                      {item.form_data.app_shop_data && item.form_data.app_shop_data.county_name}
                                    </div>
                                  </div>
                                  {item.form_data.app_shop_data && item.form_data.app_shop_data.distance && (
                                    <div>
                                      {item.form_data.app_shop_data.distance}
                                    </div>
                                  )}
                                </div>
                                {item.form_data.is_vip_goods == 1 && (
                                  <div className="price-vip-box">
                                    <img
                                      className="price-vip-image"
                                      src="http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/vip-price.png"
                                    />
                                    <span>
                                      {item.form_data.virtual_price != 0
                                        ? '会员' +
                                        item.form_data.vip_discount +
                                        '折'
                                        : '会员价'}
                                    </span>
                                  </div>
                                )}
                                {item.form_data.is_vip_goods != 1 &&
                                  item.form_data.virtual_price != 0 &&
                                  data.customFeature.virtualPriceOption != 3 &&
                                  data.customFeature.priceOption != 3 && (
                                    <div className="real-price-box">
                                      {item.form_data.discount + '折'}
                                    </div>
                                  )}
                              </div>
                              <div className="price-btn">
                                {item.form_data.is_vip_goods == 1 ? (
                                  <React.Fragment>
                                    <div className="price-box">
                                      {item.form_data
                                        .price_break_discounts_activity_id > 0 && (
                                          <span className="discount">满减</span>
                                        )}
                                      <span
                                        style={{color: data.storeStyle.theme}}
                                        className="real-price"
                                      >
                                        {'¥' + item.form_data.price}
                                      </span>
                                      <div></div>
                                    </div>
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    <div className="price-box">
                                      {item.form_data
                                        .price_break_discounts_activity_id > 0 && (
                                          <span className="discount">满减</span>
                                        )}
                                      <span
                                        style={{color: data.storeStyle.theme}}
                                        className="real-price"
                                      >
                                        {'¥' + item.form_data.price}
                                      </span>
                                      {item.form_data.is_vip_goods != 1 && (
                                        <span className="virtual-price">
                                          {item.form_data.virtual_price != 0
                                            ? '¥' + item.form_data.virtual_price
                                            : ''}
                                        </span>
                                      )}
                                      {item.discountStr &&
                                        item.form_data.integral == '1' && (
                                          <span
                                            style={{
                                              color: data.storeStyle.theme,
                                              background: data.storeStyle.theme +
                                              '33'
                                            }}
                                            className="express-new two-style-discount"
                                          >
                                            <span
                                              style={{
                                                borderRightColor: data.storeStyle.theme +
                                                '33'
                                              }}
                                              className="trangel"
                                            ></span>
                                            {item.discountStr}
                                          </span>
                                        )}
                                    </div>
                                  </React.Fragment>
                                )}
                                <div className="submit-btn">立即抢</div>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </React.Fragment>
                )
              }
            </React.Fragment>
          )
        }
        {
          data.customFeature.mode == 1 && (
            <div className="new-goods-list-two clearfix">
              {
                data.goods_data && data.goods_data.map((item, index) => (
                  <div className="goods-content" key={index} data-id={item.form_data.id} data-goods-type={item.form_data.goods_type} data-app-id={item.form_data.app_id} data-group={item.form_data.is_group_buy} data-presell={item.form_data.is_presell_goods} data-groupid={item.form_data.group_buy_activity_id} style={itemStyleObj} onClick={this.turnToGoodsDetail}>
                    <img className="list-img" src={item.form_data.cover} style={itemImgStyleObj} mode="scaleToFill" />
                    {
                      item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 &&
                      <img className="goods-subscript" src={item.form_data.corner_url} />
                    }
                    <div className="title">
                      {
                        item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                        <img className="title-subscript" src={item.form_data.corner_url} />
                      }
                      {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                    </div>
                    {
                      data.customFeature.styleMode == '1-1' &&
                      <div className="goods-detail">
                        <div className="discount-box">
                          {
                            item.form_data.is_vip_goods == 1 &&
                            <span className="vip-logo" style={{
                              marginRight: '.10rem'
                            }}>会员价</span>
                          }
                          {
                            item.form_data.virtual_price != 0 &&
                            <span className="discount" style={{
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            }}>
                              {
                                item.form_data.is_vip_goods != 1 ? `${item.form_data.discount}折优惠` : `${item.form_data.vip_discount}折优惠`
                              }
                            </span>
                          }
                          {
                            isFree(item) &&
                            <span className="express" style={{
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            }}>包邮</span>
                          }
                        </div>
                        <div className="price-box">
                          {
                            item.form_data.is_vip_goods != 1 ?
                              <React.Fragment>
                                <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                {
                                  item.form_data.virtual_price != 0 &&
                                  <span className="virtual-price">¥{item.form_data.virtual_price}</span>
                                }
                              </React.Fragment>
                              :
                              <React.Fragment>
                                <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.vip_min_price}</span>
                                {
                                  item.form_data.price != 0 &&
                                  <span className="virtual-price" style={{
                                    textDecoration: 'inherit',
                                    position: 'relative',
                                    top: '.02rem'
                                  }}>¥{item.form_data.price}</span>

                                }
                              </React.Fragment>
                          }
                        </div>
                        <div className="sales-box">
                          <span className="sales">{item.form_data.sales}人付款</span>
                          {
                            item.form_data.is_group_buy != 1 &&
                            <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                          }
                        </div>
                      </div>
                    }
                    {
                      data.customFeature.styleMode == '1-2' &&
                      <div className="goods-detail two-two-mode">
                        {
                          item.form_data.is_vip_goods == 1 ?
                            <div className="price-box">
                              <span style={{
                                fontSize: '24rpx',
                                color: '#999',
                                position: 'relative',
                                top: '.06rem'
                              }} className="real-price">¥{item.form_data.price}</span>
                              {
                                item.form_data.virtual_price != 0 &&
                                <span style={{
                                  color: data.storeStyle.theme,
                                  background: data.storeStyle.theme + '33',
                                  position: 'relative',
                                  top: '.05rem'
                                }} className="discount two-style-discount vip-trangel">
                                  <span style={{
                                    borderRightColor: data.storeStyle.theme + '33',
                                    marginTop: '.10rem'
                                  }} className="trangel"></span>{item.form_data.discount}折
                                </span>
                              }
                              <div>
                                <span style={{ color: data.storeStyle.theme }}
                                  className="real-price">¥{item.form_data.vip_min_price}</span>
                                <span style={{
                                  color: data.storeStyle.theme,
                                  background: data.storeStyle.theme + '33',
                                }} className="discount two-style-discount">
                                  <span style={{
                                    borderRightColor: data.storeStyle.theme + '33'
                                  }} className="trangel"></span>
                                  {item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'}
                                </span>
                              </div>
                            </div>
                            :
                            (
                              <React.Fragment>
                                {
                                  item.form_data.is_vip_goods != 1 &&
                                  <span className="virtual-price" >{item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''}</span>
                                }
                                <div className="price-box">
                                  <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                  {
                                    item.form_data.virtual_price != 0 &&
                                    <span style={{
                                      color: data.storeStyle.theme,
                                      background: data.storeStyle.theme + '33'
                                    }} className="discount two-style-discount">
                                      <span style={{
                                        borderRightColor: data.storeStyle.theme + '33'
                                      }} className="trangel"></span>
                                      {item.form_data.discount}折
                                    </span>
                                  }
                                </div>
                              </React.Fragment>
                            )

                        }
                        <div className="sales-box">
                          {
                            isFree(item) &&
                            <span className="express" style={{
                              color: data.storeStyle.theme,
                              borderColor: data.storeStyle.theme + '33'
                            }}>包邮</span>
                          }
                          <span className="sales">{item.form_data.sales}人付款</span>
                          {
                            item.form_data.is_group_buy != 1 &&
                            <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                          }
                        </div>
                      </div>
                    }
                  </div>
                ))
              }
            </div>
          )
        }
        {
          data.customFeature.mode == 2 && (
            <div className="new-goods-list-three">
              {
                data.goods_data && data.goods_data.map((item, index) => (
                  <div className="goods-content" key={index} data-id={item.form_data.id} data-goods-type={item.form_data.goods_type} data-app-id={item.form_data.app_id} data-group={item.form_data.is_group_buy} data-presell={item.form_data.is_presell_goods} data-groupid={item.form_data.group_buy_activity_id} style={itemStyleObj} onClick={this.turnToGoodsDetail}>
                    <img className="list-img" src={item.form_data.cover} style={itemImgStyleObj} mode="scaleToFill" />
                    {
                      item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 &&
                      <img className="goods-subscript" src={item.form_data.corner_url} />
                    }
                    <div className="title">
                      {
                        item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                        <img className="title-subscript" src={item.form_data.corner_url} />
                      }
                      {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                    </div>
                    {
                      data.customFeature.styleMode == '2-1' &&
                      <div className="goods-detail">
                        <div className="discount-box">
                          {
                            item.form_data.is_vip_goods == 1 &&
                            <span className="vip-logo" style={{
                              marginRight: '.10rem'
                            }}>会员价</span>
                          }
                          {
                            item.form_data.virtual_price != 0 &&
                            <span className="discount" style={{
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            }}>
                              {
                                item.form_data.is_vip_goods != 1 ? `${item.form_data.discount}折优惠` : `${item.form_data.vip_discount}折优惠`
                              }
                            </span>
                          }
                          {
                            isFree(item) &&
                            <span className="express" style={{
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            }}>包邮</span>
                          }
                        </div>
                        <div className="price-box">
                          {
                            item.form_data.is_vip_goods != 1 ?
                              <React.Fragment>
                                <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                {
                                  item.form_data.virtual_price != 0 &&
                                  <span className="virtual-price">¥{item.form_data.virtual_price}</span>
                                }
                              </React.Fragment>
                              :
                              <React.Fragment>
                                <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.vip_min_price}</span>
                                {
                                  item.form_data.price != 0 &&
                                  <span className="virtual-price" style={{
                                    textDecoration: 'inherit',
                                    position: 'relative',
                                    top: '.02rem'
                                  }}>¥{item.form_data.price}</span>

                                }
                              </React.Fragment>
                          }
                        </div>
                        <div className="sales-box">
                          <span className="sales">{item.form_data.sales}人付款</span>
                          {
                            item.form_data.is_group_buy != 1 &&
                            <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                          }
                        </div>
                      </div>
                    }
                    {
                      data.customFeature.styleMode == '2-2' &&
                      <div className="goods-detail three-two-mode">
                        {
                          item.form_data.is_vip_goods == 1 ?
                            <div className="price-box">
                              <span style={{
                                fontSize: '24rpx',
                                color: '#999',
                                position: 'relative',
                                top: '.06rem'
                              }} className="real-price">¥{item.form_data.price}</span>
                              {
                                item.form_data.virtual_price != 0 &&
                                <span style={{
                                  color: data.storeStyle.theme,
                                  background: data.storeStyle.theme + '33',
                                  position: 'relative',
                                  top: '.05rem'
                                }} className="discount two-style-discount vip-trangel">
                                  <span style={{
                                    borderRightColor: data.storeStyle.theme + '33',
                                    marginTop: '.10rem'
                                  }} className="trangel"></span>{item.form_data.discount}折
                                </span>
                              }
                              <div>
                                <span style={{ color: data.storeStyle.theme }}
                                  className="real-price">¥{item.form_data.vip_min_price}</span>
                                <span style={{
                                  color: data.storeStyle.theme,
                                  background: data.storeStyle.theme + '33',
                                }} className="discount two-style-discount">
                                  <span style={{
                                    borderRightColor: data.storeStyle.theme + '33'
                                  }} className="trangel"></span>
                                  {item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'}
                                </span>
                              </div>
                            </div>
                            :
                            (
                              <React.Fragment>
                                {
                                  item.form_data.is_vip_goods != 1 &&
                                  <span className="virtual-price" >{item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''}</span>
                                }
                                <div className="price-box">
                                  <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                  {
                                    item.form_data.virtual_price != 0 &&
                                    <span style={{
                                      color: data.storeStyle.theme,
                                      background: data.storeStyle.theme + '33'
                                    }} className="discount two-style-discount">
                                      <span style={{
                                        borderRightColor: data.storeStyle.theme + '33'
                                      }} className="trangel"></span>
                                      {item.form_data.discount}折
                                    </span>
                                  }
                                </div>
                              </React.Fragment>
                            )

                        }
                        <div className="sales-box">
                          {
                            isFree(item) &&
                            <span className="express" style={{
                              color: data.storeStyle.theme,
                              borderColor: data.storeStyle.theme + '33'
                            }}>包邮</span>
                          }
                          <span className="sales">{item.form_data.sales}人付款</span>
                          {
                            item.form_data.is_group_buy != 1 &&
                            <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                          }
                        </div>
                      </div>
                    }
                  </div>
                ))
              }
            </div>
          )
        }
        {
          data.customFeature.mode == 3 && (
            <div className={`new-goods-list-four ${data.customFeature.styleMode == '3-3' ? 'list-padding' : ''}`}>
              {
                data.goods_data && data.goods_data.map((item, index) => (
                  <div className={`goods-content ${data.customFeature.styleMode == '3-3' ? 'list-border' : ''}`} key={index} data-id={item.form_data.id} data-goods-type={item.form_data.goods_type} data-app-id={item.form_data.app_id} data-group={item.form_data.is_group_buy} data-presell={item.form_data.is_presell_goods} data-groupid={item.form_data.group_buy_activity_id} style={itemStyleObj} onClick={this.turnToGoodsDetail}>
                    <img className={`goods-image ${data.customFeature.styleMode == '3-3' ? 'image-border' : ''}`} src={item.form_data.cover} style={itemImgStyleObj} mode="scaleToFill" />
                    {
                      item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 &&
                      <img className="goods-subscript" src={item.form_data.corner_url} />
                    }
                    {
                      data.customFeature.styleMode == '3-1' &&
                      <div className="goods-detail">
                        <div className="title">
                          {
                            item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                            <img className="title-subscript" src={item.form_data.corner_url} />
                          }
                          {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                        </div>
                        <div className="discount-box">
                          {
                            item.form_data.is_vip_goods == 1 &&
                            <span className="vip-logo" style={{
                              marginRight: '.10rem'
                            }}>会员价</span>
                          }
                          {
                            item.form_data.virtual_price != 0 &&
                            <span className="discount" style={{
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            }}>
                              {
                                item.form_data.is_vip_goods != 1 ? `${item.form_data.discount}折优惠` : `${item.form_data.vip_discount}折优惠`
                              }
                            </span>
                          }
                          {
                            isFree(item) &&
                            <span className="express" style={{
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            }}>包邮</span>
                          }
                          <span className="sales">{item.form_data.sales}人付款</span>
                        </div>
                        <div className="price-box">
                          {
                            item.form_data.is_vip_goods != 1 ?
                              <React.Fragment>
                                <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                {
                                  item.form_data.virtual_price != 0 &&
                                  <span className="virtual-price">¥{item.form_data.virtual_price}</span>
                                }
                              </React.Fragment>
                              :
                              <React.Fragment>
                                <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.vip_min_price}</span>
                                {
                                  item.form_data.price != 0 &&
                                  <span className="virtual-price" style={{
                                    textDecoration: 'inherit',
                                    position: 'relative',
                                    top: '.02rem'
                                  }}>¥{item.form_data.price}</span>

                                }
                              </React.Fragment>
                          }
                          {
                            item.form_data.is_group_buy != 1 &&
                            <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                          }
                        </div>
                      </div>
                    }
                    {
                      data.customFeature.styleMode == '3-2' &&
                      <div className="goods-detail four-two-mode">
                        <div className="title">
                          {
                            item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                            <img className="title-subscript" src={item.form_data.corner_url} />
                          }
                          {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                        </div>
                        {
                          item.form_data.is_vip_goods == 1 ?
                            <div className="price-box">
                              <span style={{ color: data.storeStyle.theme }}
                                className="real-price">¥{item.form_data.vip_min_price}</span>
                              <span style={{
                                color: data.storeStyle.theme,
                                background: data.storeStyle.theme + '33',
                              }} className="discount two-style-discount">
                                <span style={{
                                  borderRightColor: data.storeStyle.theme + '33'
                                }} className="trangel"></span>
                                {item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'}
                              </span>
                            </div>
                            :
                            (
                              <React.Fragment>
                                <div className="price-box">
                                  <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                  {
                                    item.form_data.virtual_price != 0 &&
                                    <span className="virtual-price">¥{item.form_data.virtual_price}</span>
                                  }
                                  {
                                    item.form_data.virtual_price != 0 &&
                                    <span style={{
                                      color: data.storeStyle.theme,
                                      background: data.storeStyle.theme + '33'
                                    }} className="discount two-style-discount">
                                      <span style={{
                                        borderRightColor: data.storeStyle.theme + '33'
                                      }} className="trangel"></span>
                                      {item.form_data.discount}折
                                    </span>
                                  }
                                </div>
                              </React.Fragment>
                            )

                        }
                        <div className="discount-box">
                          {
                            isFree(item) &&
                            <span className="express" style={{
                              color: data.storeStyle.theme,
                              borderColor: data.storeStyle.theme + '33'
                            }}>包邮</span>
                          }
                          <span className="sales">{item.form_data.sales}人付款</span>
                          {
                            item.form_data.is_group_buy != 1 &&
                            <label style={{ color: data.storeStyle.theme }} className="shopping-icon ico-moon icon-addshoppingcart5" data-id={item.form_data.id} data-app-id={item.form_data.app_id} onClick={this.showGoodsShoppingcart}></label>
                          }
                        </div>
                      </div>
                    }
                    {
                      data.customFeature.styleMode == '3-3' &&
                      <div className="goods-detail four-three-mode">
                        <div className="title">
                          {
                            item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                            <img className="title-subscript" src={item.form_data.corner_url} />
                          }
                          {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                        </div>
                        {
                          item.form_data.is_vip_goods == 1 ?
                            <div className={`price-box ${data.customFeature.styleMode == '3-3' ? 'df' : ''}`}>
                              <div>
                                <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.vip_min_price}</span>
                                {
                                  item.discountStr && item.form_data.integral == '1' && <span style={{ color: data.storeStyle.theme, background: data.storeStyle.theme + '33' }} className="express-new two-style-discount">
                                  </span>
                                }
                                <span style={{ color: data.storeStyle.theme, background: data.storeStyle.theme + '33' }} className="discount two-style-discount">
                                  {item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'}
                                </span>
                              </div>
                              <div className='purchase-btn' style={{ background: data.storeStyle.theme, boxShadow: `0.03rem 0.12rem 0.18rem ${data.storeStyle.theme + '33'}` }}>立即购买</div>
                            </div>
                            :
                            (
                              <React.Fragment>
                                <div className={`price-box ${data.customFeature.styleMode == '3-3' ? 'df' : ''}`}>
                                  <div>
                                    <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                                    {
                                      item.form_data.virtual_price != 0 &&
                                      <span className="virtual-price">市场价¥{item.form_data.virtual_price}</span>
                                    }
                                    {
                                      item.form_data.virtual_price != 0 &&
                                      <span style={{
                                        color: data.storeStyle.theme,
                                        background: data.storeStyle.theme + '33'
                                      }} className="discount two-style-discount">
                                        {item.form_data.discount}折
                                      </span>
                                    }
                                    {
                                      isFree(item) &&
                                      <span className="express" style={{
                                        color: data.storeStyle.theme,
                                        borderColor: data.storeStyle.theme,
                                        background: data.storeStyle.theme ? 'none' : ''
                                      }}>包邮</span>
                                    }
                                  </div>
                                  <div className='purchase-btn' style={{ background: data.storeStyle.theme, boxShadow: `0.03rem 0.12rem 0.18rem ${data.storeStyle.theme + '33'}` }}>立即购买</div>
                                </div>
                              </React.Fragment>
                            )

                        }
                      </div>
                    }
                  </div>
                ))
              }
            </div>
          )
        }
        {
          data.customFeature.mode == 4 && (
            <React.Fragment>
              {data.customFeature.styleMode == '4-1' &&
                <div className="new-goods-list-five">
                  {data.goods_data && data.goods_data.map((item, index) => {
                    return (
                      <div className="goods-content" key={index} data-id={item.form_data.id} data-goods-type={item.form_data.goods_type} data-app-id={item.form_data.app_id} onClick={this.turnToGoodsDetail} data-group={item.form_data.is_group_buy}
                        data-presell={item.form_data.is_presell_goods} data-group-id={item.form_data.group_buy_activity_id} style={itemStyleObj}>
                        <div className="goods-image" style={{ ...itemImgStyleObj, backgroundImage: `url(${item.form_data.cover})` }}>
                          {item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 &&
                            <img className="goods-subscript" src={item.form_data.corner_url} />
                          }
                        </div>
                        <div className="good_detail">
                          <div className="title">
                            {item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 &&
                              <img className="title-subscript" src={item.form_data.corner_url} />
                            }
                            {item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}
                          </div>
                          <span style={{ color: data.storeStyle.theme }} className="real-price">¥{item.form_data.price}</span>
                          {item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && !(isImage(data.customFeature.addShoppingCartImageSrc) < 0) &&
                            <label style={{ color: data.storeStyle.theme }}
                              className={`shopping-icon ico-moon icon-${data.customFeature.addShoppingCartImageSrc}`}
                              data-id={item.form_data.id}
                              data-app-id={item.form_data.app_id}
                              data-ispackage={item.form_data.is_package_goods}
                              onClick={this.showGoodsShoppingcart} data-buynow={data.customFeature.isBuyNow}></label>
                          }
                          {
                            item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && (isImage(data.customFeature.addShoppingCartImageSrc) < 0) &&
                            <label style={{ color: data.storeStyle.theme }}
                              className="shopping-icon"
                              data-id={item.form_data.id}
                              data-app-id={item.form_data.app_id}
                              data-ispackage={item.form_data.is_package_goods}
                              onClick={this.showGoodsShoppingcart} data-buynow={data.customFeature.isBuyNow}>
                              <img className="image" src={data.customFeature.addShoppingCartImageSrc} />
                            </label>
                          }
                        </div>
                      </div>
                    )
                  })}
                </div>
              }
            </React.Fragment>
          )
        }
        <Others></Others>
      </ScrollView>
    )

    return (
      <div className="custom-component goods-list">
        {
          customFeature.controlCheck ?
            <IntegralGoodsList></IntegralGoodsList>
            :
            !customFeature.styleMode ?
              <GoodsList></GoodsList>
              :
              <NewGoodsList></NewGoodsList>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/goods-list-custom-component/GoodsListCustomComponent.jsx